module.exports = __webpack_public_path__ + "adding-teammates-hero-6aa462f7bf7d390bd558fc401672fc40.png";